import React from "react";
import "./index.css";
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
} from "@mui/material";

const ServiceCard = ({ services }) => {
  return (
    <Box
      sx={{
        bgcolor: "transparent",
        color: "white",
        padding: { xs: "40px 20px", md: "40px 40px" },
      }}
    >
      <Container
        sx={{
          //   border: "2px solid rgba(255, 255, 255, 0.3)",
          textAlign: "center",
          //   padding: "40px 20px",
        }}
      >
        <Box
          sx={{
            border: "2px solid rgba(255, 255, 255, 0.3)",
            borderRadius: 4,
            padding: "30px",
            bgcolor: "#19222c",
            // backdropFilter: "blur(10px)",
            backdropFilter: "blur(15px)" /* Glass effect */,
          }}
        >
          <Typography variant="h5" fontWeight="bold" color="white" mb={3}>
            Tailored Services for Real Estate Businesses
          </Typography>

          <Grid container spacing={3} justifyContent="center">
            {services.map((service, index) => (
              <Grid item xs={12} md={5} key={index}>
                <Card
                  className="business-service-card"
                  sx={{
                    borderRadius: 3,
                    color: "white",
                    textAlign: "left",
                    p: 2,
                    height: "100%",
                  }}
                >
                  <CardContent>
                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                      <img
                        src={service.image}
                        alt={service.title}
                        style={{ width: "80px", height: "80px" }}
                      />
                      <Typography
                        variant="h6"
                        fontWeight="bold"
                        sx={{ color: "white" }}
                      >
                        {service.title}
                      </Typography>
                    </Box>
                    <ul style={{ listStyleType: "disc" }}>
                      {service.description.map((desc, i) => (
                        <li key={i}>{desc}</li>
                      ))}
                    </ul>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default ServiceCard;
